import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { voipCallStartTime } from '../../../../../redux/actions/addOns/voip/voipActions';

export default function CallTimer(props) {
  const { callStatus, call_start_time, className } = props;
  const [startTime, setStartTime] = useState(call_start_time);
  const dispatch = useDispatch()

  const handleTimerCal = () => {
    const currentTime = Date.now();
    const elapsedTime = currentTime - startTime;
    const minutes = Math.floor(elapsedTime / 60000);
    const seconds = Math.floor((elapsedTime % 60000) / 1000);
    const formattedTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    return (formattedTime && formattedTime.length < 6) ? formattedTime : '0:00'
  }

  const [timer, setTimer] = useState(handleTimerCal());

  useEffect(() => {
    let intervalId;
    if (callStatus === 'call_started') {
      !call_start_time && dispatch(voipCallStartTime(new Date()))
      setStartTime(call_start_time ?? new Date());
      intervalId = setInterval(() => {
        setTimer(handleTimerCal());
      }, 1000); // Update timer every second
    }
    if (callStatus === 'call_ended') {
      clearInterval(intervalId);
      dispatch(voipCallStartTime(null))
    }
    return () => clearInterval(intervalId);
  }, [callStatus, startTime]);

  return (
    <p className={`${className ?? 'text-center pt-4'} mb-0`}>{timer}</p>
  );
}

